export default {
  ARCHIVED: 'Archived',
  NEW: 'NEW',
  NEW_PASSWORD: 'Enter new password',
  REPEAT_NEW_PASSWORD: 'Repeat new password',
  PASSWORD_IS_REQUIRED: 'Password is required',
  PASSWORDS_MUST_MATCH: 'Passwords must match',
  PASSWORD_CHANGED_SUCCESSFULLY: 'Password changed successfully',
  INFORMATION: 'Information',
  SERVICE: 'Service',
  STATUS: 'Status',
  EXTEND_TIME: 'Extend time',
  TIME_EXTENDED: 'Time extended!',
  NEW_CLIENTS_ONLY: 'New clients only',
  ONE_TIME_DISCOUNT: 'One time discount',
  PAYMENT_METHOD_REQUIRED: 'Payment method required',
  GENERATE_ONE_TIME_PROMO_CODES: 'One-time promo codes',
  ICON_FOR_APP: 'Icon for app',
  SELECT_CAMPAIGN: 'Select campaign',
  WHICH_WILL_BE_VALID_FOR: 'Which will be valid for',
  AFTER: 'After',
  DAYS: 'days',
  ACTIVATE: 'Activate',
  CREATE_NEW_CAMPAIGN: 'Create new Campaign',
  ACTIVATE_NEW_CAMPAIGN: 'Activate new campaign',
  PROMO_CODES: 'Promo codes',
  CREATE_NEW_PROMO_CODES: 'Create new promo codes',
  AMOUNT_OF_NEW_CODES: 'Number of new code',
  DETAILS: 'Details',
  COPY: 'Copy',
  RESET_PASSWORD: 'Reset password',
  COPY_PASSWORD_RESET_LINK: 'Copy reset link',
  LOGIN_AS_THIS_USER: 'Login as this user',
  ACTIVE_SESSION: 'Active session',
  ACTIVE_SESSIONS: 'Active sessions',
  VERIFIED: 'Verified',
  LOCATIONS: 'Places',
  ZONES: 'Zones',
  PLEASE_BE_PATIENT: 'Please be patiend...',
  SELECT_ZONE: 'Select zone',
  SELECT_PLACE: 'Select place',
  FILTERS: 'Search',
  ADD_NEW_USER: 'Add new user',
  ADD_USER_SLASH_COMPANY: 'Add user/company',
  EDIT_USER_SLASH_COMPANY: 'Edit user/company',
  ACCESS_TO_PLATFORM: 'Access enabled',
  CAN_VEW_PARKING_FINES: 'Can view parking fines',
  ENFORCEMENT_APP_ENABLED: 'Enforcement app enabled',
  IS_NEW_TENANT: 'Create whitelist for tenant',
  NAME_IS_REQUIRED: 'Name is required',
  EMAIL_IS_REQUIRED: 'Email is required',
  IN_PLACES: 'Place',
  IN_ZONES: 'Zone',
  EXPIRED: 'Expired',
  ACTIVE: 'Active',
  ACTIVE_PLURAL: 'Active',
  DOWNLOAD_TEMPLATE_FILE: 'Download template file',
  HOME: 'Home',
  TITLE: 'Title',
  MESSAGE: 'Message',
  SESSION: 'Session',
  COST_IN_EUROS: 'Cost in Euros',
  INVOICES: 'Invoices',
  noDataText: 'No data to show',
  YES: 'Yes',
  NO: 'No',
  CANCEL: 'Cancel',
  CAN_NOT_BE_UNDONE: 'This can not be undone',
  SEARCH_BY_NAME: 'Search by name...',
  PREVIEW: 'Preview',
  ARE_YOU_SURE: 'Are you sure?',
  COUNTRY_CODE: 'Country code',
  LOADING_NEW_CONTENT: 'Loading new content...',
  NEW_CONTENT_AVAILABLE: 'New content available. Please',
  REFRESH: 'REFRESH',
  YEAR: 'Year',
  MONTH: 'Month',
  EDIT: 'Edit',
  ADD: 'Add',
  DELETE: 'Delete',
  SAVE: 'Save',
  LOG_OUT: 'Log out',
  LOG_IN: 'Log in',
  BACK: 'Back',
  CLOSE: 'Close',
  LIST_EMPTY: 'List empty',
  PREVIOUS: 'Previous',
  NEXT: 'Next',
  PAGE: 'Page',
  SHOW: 'Show',
  MONDAY: 'Monday',
  TUESDAY: 'Tuesday',
  WEDNESDAY: 'Wednesday',
  THURSDAY: 'Thursday',
  FRIDAY: 'Friday',
  SATURDAY: 'Saturday',
  SUNDAY: 'Sunday',
  CURRENCY: 'Currency',
  TOTAL: 'Total',
  COUNT: 'Count',
  VALID_FROM: 'Valid from',
  VALID_TO: 'Valid to',
  DESCRIPTION: 'Description',
  IMPORT_FROM_FILE: 'Import from file',
  INVITE_FROM_FILE: 'Invite from file',
  SEARCH: 'Search',
  EXPORT_TO_EXCEL: 'Export to excel',
  COMMENTS: 'Comments/info',
  CLIENT_ID: 'Client id',
  PHONE_NUMBER: 'Phone number',
  CAR_NUMBER: 'Licence plate',
  CLIENT_ACTIVE_CAR_NUMBER: 'Client active license plate',
  EMAIL: 'Email',
  NAME: 'Name',
  LOCATION: 'Location',
  START_TIME: 'Start time',
  END_TIME: 'End time',
  INVALID_DATE: 'Invalid date',
  INVALID_TIME: 'Invalid time',
  COST: 'Cost',
  TYPE: 'Type',
  REGION: 'Region',
  ZONE: 'Zone',
  OPERATOR: 'Operator',
  GENERATE: 'Generate',
  SEND_TO_EMAIL: 'Send to e-mail',
  EMAIL_REQ_INFO: 'Registration request received message',
  EMAIL_REG_REQ_INFO: "Email info if 'Auto-approve' turned off",
  CODE: 'Code',
  ERROR_GLOBAL: 'Something went wrong! Please try again later.',
  COMMENTS_FOR_ENFORCEMENT: 'Comments for enforcement',
  PARKING_ACTIVE: 'Parking active',
  PARKING_NOT_ACTIVE: 'Parking not active',
  WITH_BOOKING: 'With booking',
  WITHOUT_BOOKING: 'Without booking',
  PARKING_SESSIONS_OVER_FREE_TIME: 'Parking sessions over free time',
  EXTRA_FILTER: 'Extra filter',
  HEADER: {
    LANGUAGE: 'Language'
  },
  EMPTY_STATE: {
    WHITELIST_EMPTY_HERE: 'Empty in here',
    WHITELIST_EMPTY_HERE_MESSAGE: 'You do not have any whitelist',
    FLEETS_EMPTY_HERE: 'Empty in here',
    FLEETS_EMPTY_HERE_MESSAGE: 'You do not have any fleets',
    USERS_EMPTY_HERE: 'Empty in here',
    USERS_EMPTY_HERE_MESSAGE:
      'You do not have any users or you do not have rights to edit users',
    WHITELISTS_VEHICLE_NUMBER_SEARCH_NO_RESULTS:
      'Given vehicle does not seem to belong to any whitelist',
    FLEETS_VEHICLE_NUMBER_SEARCH_NO_RESULTS:
      'Given vehicle does not seem to belong to any fleet'
  },
  ALLOWED_TO_CALL: {
    TITLE: 'Whitelist',
    PHONE_NUMBER: 'Phone',
    CAR_NUMBER: 'Car',
    NAME: 'Name',
    APP: 'Add to App',
    VALID_UNTIL: 'Valid to',
    INVALID_INPUTS: 'Phone number and car number required',
    CALLS: 'Log',
    CHARGE_FOR_SESSIONS: 'Charge for sessions'
  },
  DASHBOARD: {
    TITLE: 'Dashboard',
    DESCRIPTION: 'All whitelists and fleets active sessions',
    PLACES_TITLE: 'Your locations',
    PLACES_DESCRIPTION: 'All location you can manage.',
    ADDRESS: 'Address',
    THIS_MONTH_REVENUE: 'This month revenue',
    LAST_MONTH_REVENUE: 'Last month revenue',
    CHANGE_ALLOWED_TO_CALL: 'Whitelist',
    SESSIONS_TITLE: 'Sessions',
    SESSIONS_DESCRIPTION: 'All sessions under your managed locations.',
    GENERAL_FILTERS: 'Filters',
    CAR_NUMBER: 'Car number',
    RESERVATION_TIME: 'Booking time',
    START_TIME: 'Start time',
    END_TIME: 'End time',
    STATUS: 'Status',
    COST: 'Cost',
    CLIENT: 'Client',
    CLIENTS_PHONE: 'Clients phone',
    CLIENTS_NAME: 'Clients name',
    PLACE: 'Place',
    PAYMENT_INFO: 'Payment info',
    PAID_WITH_MONTHLY_PASS: 'Paid with monthly pass',
    PAID_WITH_CREDITCARD: 'Paid with creditcard',
    WHITELISTED: 'Whitelisted',
    PLACE_NAME: 'Location',
    SEARCH: 'Search',
    UTILIZATION: 'Occupancy',
    PAYMENT_FROM: 'From',
    PAYMENT_TO: 'To',
    SUMMARY: 'Summary',
    REVENUE: 'Revenue',
    MONTHLY_PASSES_REVENUE: 'Monthly passes',
    OWNERS_SHARE: "Owner's share",
    PHONE_CALL: 'Phone call',
    RFID: 'RFID',
    INVOICE: 'Invoice',
    PAYMENT_LOGS: 'Payment logs',
    CREDIT: 'Credit',
    WHITELISTS: 'Whitelists',
    FLEETS: 'Fleets',
    CAMPAIGNS: 'Campaigns',
    CAMPAIGN_CODE: 'Campaign code',
    REG_LIMIT: 'Reg. limit',
    REGISTRANTS: 'Registrants',
    NO_ACTIVE_CAMPAIGNS: 'No active campaigns',
    PAYOUTS: 'Payouts',
    USERS: 'Users',
    USERS_DESCRIPTION: 'All users you can manage',
    CAMPAIGN_DESCRIPTION: 'All campaigns',
    START_SESSION: 'Start parking',
    REPORTS: 'Reports',
    TYPES: 'Type:',
    REGIONS: 'Region:',
    ZONES: 'Zone:',
    OPERATORS: 'Operator:',
    IMPORT_FROM_FILE: 'Import from file',
    ADD_NEW_LOCATION: 'Add new location',
    CONTROLLER: 'Controller',
    STATISTICS: 'Statistics',
    MONTHLY_PASSES: 'Monthly passes',
    WHITELIST: 'Whitelist',
    EVENTS: 'Events',
    LPR: 'LPR',
    DEAL_TIMELOG: 'Deal timelog',
    SETTINGS: 'Settings',
    SETTINGS_DESCRIPTION: 'All settings',
    DAY_PASSES: 'Day passes',
    BOOKING: 'Booking',
    KIOSKS: 'Kiosks'
  },
  CONTROLLERS: {
    REFRESH: 'Refresh',
    CONTROLLER_LOGS: 'Controller logs',
    FIRMWARE: 'Firmware',
    FIRMWARE_UPDATE: 'Firmware update',
    UPDATE_FIRMWARE: 'Update firmware',
    FIRMWARE_VERSION: 'Firmware version',
    FIRMWARE_VERSION_INFORMATION_TITLE: 'Info about firmware version',
    VERSION: 'Version',
    REASON: 'Reason',
    OTA_NOTIFICATION_DESCRIPTION:
      'Currently it is not possible to update firmware over the air that starts with numbers 1.1.',
    CLOSED: 'CLOSED',
    OPENED: 'OPENED',
    ADD_CONTROLLER: 'Add controller',
    EDIT_CONTROLLER: 'Edit controller'
  },
  EDIT_PLACE: {
    SCHEDULE_VALIDITY: {
      TITLE: 'Schedule validity',
      FROM: 'From',
      TO: 'To',
      UNLIMITED: 'Unlimited'
    },
    RENTAL_SCHEDULE: {
      TITLE: 'Rental schedule',
      COPY_MONDAY_SCHEDULE: 'Copy monday to all',
      SPOTS: 'spots',
      OTHER_TIMES: 'Other times',
      IS_CLOSED: 'Closed'
    },
    MONTHLY: {
      TITLE: 'Monthly subscriptions',
      ENABLED: 'Enabled',
      MONTHLY_COST: 'Monthly cost',
      MAX_NUM: 'Max available',
      NOTIFICATION_EMAILS: 'Notification emails',
      DESCRIPTION_FOR_APP: 'Description for app',
      NO_ACTIVE_MONTHLY_PASSES: 'No active monthly passes',
      NO_EXPIRED_MONTHLY_PASSES: 'No expired monthly passes',
      UPDATED: 'Monthly pass updated successfully',
      ADDED: 'Monthly pass added successfully'
    }
  },
  LOGIN: {
    EMAIL: 'E-mail',
    PASSWORD: 'Password',
    INVALID_INPUTS: 'Invalid e-mail or password.',
    FORGOT_PASSWORD: 'Forgot password?',
    FORGOT_PASSWORD_TITLE: 'Forgot password',
    SUBMIT: 'Submit'
  },
  REGISTER: {
    REGISTER: 'Register',
    NAME: 'Name',
    EMAIL: 'E-mail',
    PHONE_NUMBER: 'Phone number',
    PASSWORD: 'Password',
    PASSWORD_AGAIN: 'Password again'
  },
  STATISTICS: {
    TITLE: 'Statistics',
    SHOW: 'Show',
    SHOW_LOG: 'Show log',
    FROM: 'From',
    TO: 'To',
    WITH_APP: 'With app',
    WITHOUT_APP: 'Without app',
    TOTAL_SESSIONS: 'Total sessions',
    TIMESTAMP: 'Timestamp',
    EVENT: 'Event',
    SESSIONS_PER_DAY: 'Parking sessions per day',
    TIME_OF_DAY: 'Time of Day',
    PARKING_SESSIONS: 'Parking sessions',
    GROUP_BY_CAR: 'Group by car nr.',
    SELF_PAID_PARKING_SESSIONS: 'Self-paid parking sessions'
  },
  WHITELISTS: {
    TITLE: 'Whitelists',
    REGION: 'Region',
    NAME: 'Name',
    VALID_IN: 'Valid in',
    APPROVED_USERS: 'Approved users',
    PENDING_USERS: 'Pending users',
    ADD_NEW: 'Add new',
    WITH_AVAILABILITY_INFO: 'With availability info',
    ACTIVE_USERS: 'Active users',
    INACTIVE_USERS: 'Inactive users'
  },
  EDIT_WHITELISTS: {
    ADD_NEW_WHITELIST: 'Add new whitelist',
    EDIT_WHITELIST: 'Edit whitelist',
    DETAILS: 'DETAILS',
    USERS: 'Users',
    SESSIONS: 'SESSIONS',
    NAME: 'Name',
    APP: 'App',
    REGION: 'Region',
    VALID_IN: 'Valid in',
    REGISTRATION_ALLOWED_UNTIL: 'Registration open til',
    REG_CODE_FOR_APP: 'Reg. code in app',
    AUTO_APPROVE: 'Approve users automatically',
    ONE_TIME_CODES: 'One time promotion codes',
    REG_NOTIFICATION_EMAILS: 'Email for notifications',
    ADD_MANAGER: 'Add manager',
    PUBLIC_REG_LINK: 'Public reg. link',
    MANAGERS: 'Managers',
    NO_MANAGERS: 'No active managers',
    CHARGE_FOR_SESSIONS: 'Charge for sessions',
    START_SESSIONS_WITH_LPR: 'Start session with LPR',
    START_SESSIONS_WITH_LPR_DESCRIPTION:
      'Session starts automatically if automatic number-plate recognition system is installed.',
    AVAILABILITY_AND_PRICING: 'Availability & pricing',
    MANAGE_AVAILABILIY_AND_PRICING: 'Manage availability & pricing',
    EMAIL_INFO_AFTER_APPROVAL: 'Email body after successful registration',
    WHITELIST_USERS: 'Whitelist users',
    INVITE: 'Send invite',
    ADD_NEW: 'Add new',
    PHONE_NUMBER: 'Phone nr',
    CAR_NUMBERS: 'Licence plates',
    USER_NAME: 'Name',
    EMAIL: 'Email',
    REG_TYPE: 'Reg. type',
    REG_TIME: 'Reg. time',
    COMMENTS: 'Comments',
    STATUS: 'Status',
    ACTIVE_SESSIONS: 'Active sessions',
    SESSION_ID: 'Session ID',
    LOCATION: 'Location',
    CAR_NUMBER: 'License plate',
    START_TIME: 'Start time',
    END_TIME: 'End time',
    OVERTIME_MINUTES: 'Over-time minutes',
    OVER_ALLOWED_SPOTS_LIMIT_MINUTES: 'Parked minutes over allowed spots limit',
    OVER_ALLOWED_SPOTS_LIMIT_NUMBER_OF_PARKING_SESSIONS:
      'Number of parking sessions over allowed spots limit',
    REPORT: 'Report',
    TYPE: 'Raport type',
    SESSIONS_COUNT: 'Session count',
    PARKED_MINUTES: 'Parked minutes',
    COST: 'Cost',
    NO_ACTIVE_SESSIONS: 'No active sessions',
    SELECT_WHITELIST: 'Select whitelist',
    MAX_NUMBER_OF_VEHICLES: 'Max number of users/vehicles',
    DEFAULT_MAX_NUMBER_OF_VEHICLES_FOR_REGISTERED_CLIENT:
      'Default maximum number of vehicles for registered client',
    PLACE_REQUIRED:
      'Selecting at least 1 place required if valid in is "Place"',
    ZONE_REQUIRED: 'Selecting at least 1 zone required if valid in is "Zone"',
    MAX_NUMBER_OF_USER_VEHICLES: 'Max number of vehicles',
    USE_OWN_AVAILABILITY_AND_PRICING: 'Use special availability and pricing',
    ALLOW_PARKING_WITH_NO_SPOTS: 'Allow parking with no spots',
    ADD_TO_FAVORITES: 'Add to favorites',
    REMOVE_FROM_FAVORITES: 'Remove from favorites',
    ADDED_TO_FAVORITES: 'Whitelist added to Favorites',
    REMOVED_FROM_FAVORITES: 'Whitelist removed from Favorites',
    EXPIRATION_WARNING_TITLE: 'This will affect {0} users',
    EXPIRATION_WARNING_TITLE_ONE: 'This will affect 1 user',
    EXPIRATION_WARNING_BODY:
      'Some users currently have a later expiration date than the user group. Their access will end on {0} unless the group expiration date is extended.'
  },
  AVAILABILITY_TABLE: {
    TITLE: 'Availability & pricing',
    SUB_TITLE: '',
    '24H_COST': '24h cost',
    OTHER_TIMES: 'Other times',
    NUMBER_OF_SPOTS: 'Number of spots',
    HOURLY_RATE: 'Hourly rate',
    MIN_COST: 'Minimum cost',
    MAX_COST: 'Maximum cost'
  },
  FLEETS: {
    TITLE: 'Fleets',
    ADD_NEW: 'Add new',
    REGION: 'Region',
    NAME: 'Name',
    TYPE: 'Type',
    REG_CODE: 'Reg. code',
    USERS_LIMIT: 'Allowed user limit',
    USERS: 'Users',
    REPORT: 'Reports',
    DEFAULT_MINUTES_INFORMATION:
      'Selected place has set default parking minutes:'
  },
  EDIT_FLEETS: {
    TITLE: 'Fleets',
    NAME: 'Name',
    TYPE: 'Type',
    REGION: 'Region',
    VALID_IN: 'Valid in',
    APP: 'Äpp',
    DEF_DAILY_LIMIT: 'Default daily limit',
    DEF_MONTHLY_LIMIT: 'Default monthly limit',
    MAX_NUMBER_OF_USERS: 'Max limit of users',
    RESET_LIMITS: 'Reset limit beginning of month',
    REG_OPEN_TIL: 'Registration open until',
    REG_CODE_APP: 'Code for activation in app',
    AUTO_APPROVE: 'Confirm users automatically',
    ONE_TIME_PROMO_CODES: 'One-time promo codes for app',
    REG_NOTIFICATION_EMAIL: 'Email for notifications',
    PUBLIC_REG_LINK: 'Public registration link',
    START_WITH_LPR: 'Start session with LPR',
    ADD_MANAGER: 'Add manager',
    MANAGERS: 'Managers',
    NO_MANAGERS: 'No managers',
    EMAIL_BODY_AFTER_REGISTRATION:
      'Email content after successful registration',
    DESC_FOR_APP: 'Description for app',
    PHONE_NUMBER: 'Phone number',
    CAR_NUMBER: 'Licence plate',
    USER_NAME: 'Name',
    EMAIL: 'Email',
    DAILY_LIMIT: 'Daily limit',
    MONTHLY_LIMIT: 'Monthly limit',
    REG_TYPE: 'Reg. type',
    REG_TIME: 'Reg. time',
    STATUS: 'Status',
    INVITE: 'Send invite',
    ADD_NEW: 'Add new',
    FLEET_USERS: 'Users',
    SELECT_FLEET: 'Select fleet',
    ADD_NEW_FLEET: 'Add new fleet',
    EDIT_FLEET: 'Edit fleet',
    PLACE_REQUIRED:
      'Selecting at least 1 place required if valid in is "Place"',
    ZONE_REQUIRED: 'Selecting at least 1 zone required if valid in is "Zone"'
  },
  FLEET_REPORT: {
    LIMIT: 'Monthly limit:',
    USED_TOTAL: 'Used:',
    DAILY_LIMIT: 'Daily limit',
    MONTHLY_LIMIT: 'Monthly limit',
    USED_FLEET_CREDIT: 'Used credit',
    AVAILABLE_FLEET_CREDIT: 'Available credit',
    OVER_LIMIT: 'Over limit',
    SELF_PAID: 'Self paid'
  },
  REPORTS: {
    TITLE: 'Reports',
    DESCRIPTION: 'All reports',
    REPORT_TYPE: 'Report type',
    GROUP_BY: 'Group by'
  },
  ADD_SESSION: {
    TITLE: 'Add session',
    HOURS: 'Hours',
    DAYS: 'Days',
    MINUTES: 'Minutes'
  },
  ENFORCEMENT: {
    ENFORCER: 'Enforcer',
    ENFORCEMENT: 'Enforcement',
    REASON: 'Reason',
    ADDITIONAL_REASON_CODE: 'Additional reason(code)',
    ADDITIONAL_REASON_TEXT: 'Additional reason(text)',
    CREATED_AT: 'Issued at',
    LOOK_IMAGES: 'Look images',
    MARK_AS_PAID: 'Mark fine as paid',
    CANCEL_FINE: 'Cancel fine',
    FINE_PAYMENT_DATE: 'Date of receipt of payment',
    NO_IMAGES_TO_SHOW: 'No images (no images taken)',
    PAID_AMOUNT: 'Paid amount',
    OVERDUE: 'Overdue',
    EDIT_PARKING_FINE: 'Edit parking fine',
    VEHICLE_NUMBER_COUNTRY: 'Country of registration',
    LOCATION: 'Location',
    ISSUER_NAME: 'Enforcer',
    PARKING_FINES: 'Parking fines',
    PAYMENT_DATE_REQUIRED: 'Payment date is required',
    PAID_AMOUNT_REQUIRED: 'Paid amount is required',
    DEBTS_SENT: 'Debts sent',
    DEBTS_SENT_YES: 'YES',
    DEBTS_SENT_NO: 'NO',
    DEBT_INCOMES: 'Incomes',
    AMOUNT_RECEIVED: 'Amount received',
    RECEIVED_INCOME_DATE: 'Date of income received',
    MARK_RECEIVED_INCOME: 'Mark income',
    INCOMES: 'Incomes',
    DOWNLOAD_PARKING_FINE_PDF: 'Download PDF',
    ID: 'Id',
    VOID_TIME: 'Void time',
    PARKING_FINE: 'Parking fine',
    ALSO_CREATE_NEW_FINE: 'Also create new parking fine',
    LAST_AMOUNT: 'Last cost',
    PARKING_FINE_INVOICES: 'Invoices',
    PARKING_FINE_INVOICE_NUMBER: 'Number',
    PARKING_FINE_INVOICE_DATE: 'Date',
    PARKING_FINE_AMOUNT: 'Amount',
    COMMENTS: 'Comments',
    COMMENT: 'Comment',
    NO_COMMENTS: 'No comments...',
    REFERENCE_NUMBER: 'Reference number',
    PARKING_FINE_PROFILE_BENEFICIARY: 'Beneficiary',
    SEND_FINE_TO_JULIANUS: 'Forward to Julianus',
    RESET_PARKING_FINE: 'Reset parking fine',
    DO_NOT_FORWARD_DEBTS: 'Do not forward debts',
    HAS_SENT_APPEAL: 'Has sent appeal',
    PARKING_FINE_UPDATED_SUCCESSFULLY: 'Parking fine updated successfully',
    DEBTS_WILL_BE_FORWARDED_AT: 'Debts forwarding extended to::',
    PARKING_STATUS_CHECK_LOGS: 'License plate checks',
    CHECKED_AT: 'Checked at',
    HAD_PARKING: 'Parking',
    INCOME_RECEIVED_VIA_CHANNEL: 'Channel',
    INCOME_INSERTER: 'Inserter',
    INCOME_RECEIVED_AT: 'Amount received at',
    FORWARD_DEBTS_AT: 'Forward debts at',
    COMMENTS_REQUIRED: 'Comment is required',
    PARKING_FINE_REPORTS: {
      TITLE: 'Automated reports',
      EDIT: 'Edit',
      ADD_NEW: 'Add new',
      EMAIL_TO: 'E-mail To address(es)',
      EMAIL_BCC: 'E-mail BCC address(es)',
      SENDING_DAYS: 'Days when to generate/send',
      IS_MONTHLY_REPORTING_ENABLED: 'Reporting enabled',
      NEW_VEHICLE_GROUP_NAME: 'New group name',
      NEW_VEHICLE_GROUP_NAME_IS_REQUIRED: 'New vehicle group name is required',
      VEHICLE_LIST: 'Vehicle list',
      NEW_TASK_ADDED_SUCCESSFULLY: 'New reporting task created successfully'
    },
    ENFORCEMENT_OFFICERS: {
      TITLE: 'Enforcement officers',
      ADD_NEW_OFFICER: 'Add new enforcer',
      EDIT_OFFICER: 'Edit enforcer info',
      EMAIL: 'E-mail',
      PASSWORD: 'Password',
      OFFICER_NAME: 'Name',
      GROUP: 'Group'
    },
    PARKING_FINE_PLATFORM_URL: 'Parking fine platform link',
    PENALTY_APPEAL_COMMENTS: 'Penalty appeal comments',
    PENALTY_APPEAL_COMMENTS_ADD: 'Add penalty appeal comments',
    COMMENTS_TOO_LONG: 'Comments can not be longer than 1024 characters',
    REGION: 'Region'
  },
  SETTINGS: {
    OPERATOR_SETTINGS: 'Operator settings',
    OPERATOR_SETTINGS_DESCRIPTION: 'All operator settings',
    ADD_NEW_ZONE: 'Add new zone',
    NO_ZONES: 'No zones',
    CHOOSE_ICON: 'Choose icon',
    ZONE_UPDATED: 'Zone updated successfully!',
    NEW_ZONE_ADDED: 'New zone added successfully!',
    EDIT_ZONE: 'Edit zone'
  },
  ENTER_PASSWORD: 'Enter password',
  REPEAT_PASSWORD: 'Repeat password',
  ACTIVATE_ACCOUT: 'Activate your account',
  PASSWORD_CRITERIA_MISMATCH:
    'Password must contain at least 8 characters, 1 number and 1 capital letter',
  ACCOUNT_ACTIVATED_SUCCESSFULLY:
    'Account activated! Use your new password to log in',
  AUTO_GENERATE_PASSWORD: 'Generate password automatically',
  PROFILE: 'Profile',
  SEND_OWNER_INVITE: 'Send invite',
  UPDATE_PASSWORD: 'Update password',
  SEARCH_BY_VEHICLE: 'Search by vehicle number',
  BOOKING: {
    CAR_NUMBER: 'Car',
    START_TIME: 'Start time',
    END_TIME: 'End time',
    NAME: 'Name',
    PHONE_NUMBER: 'Phone',
    EMAIL: 'Email',
    COMMENTS: 'Comment',
    SEARCH_TITLE: 'Bookings search',
    CLIENT: 'Client',
    EDIT_BOOKING: 'Edit booking',
    DELETE_BOOKING: 'Delete booking',
    ADD_NEW: 'Add new booking',
    STATUS: 'Status',
    EXTERNAL_BOOKING_NUMBER: 'External booking number',
    DATE_PLACEHOLDER: '31-12-2099',
    TIME_PLACEHOLDER: '23:59',
    START_DATE: 'Start date',
    END_DATE: 'End date',
    PARKING_STATUS_PARKING: 'Parking',
    PARKING_STATUS_NOT_PARKING: 'Not parking',
    CAR_IS_REQUIRED: 'Car is required',
    TIME_FORMAT_INCORRECT: 'Time format must be HH:MM',
    DATE_FORMAT_INCORRECT: 'Date format must be 31.01.2024',
    END_BOOKING: 'End booking',
    END_BOOKING_DESCRIPTION:
      'You are about to end booking, are you sure you would like to end this booking?',
    PUT_SUCCESSFUL: 'Booking updated successfully',
    ADD_BOOKING: 'Add booking',
    POST_SUCCESSFUL: 'Booking added successfully',
    PARKING_ACTIVE: 'Parking active',
    PARKING_NOT_ACTIVE: 'Parking not active',
    STARTING_BOOKINGS: 'Starting bookings',
    OCCUPANCY_CALENDAR: 'Occupancy calendar',
    ACTIVE_PARKINGS_CURRENTLY: 'Active parkings currently',
    COST: 'Cost',
    CREATED_AT: 'Created at'
  },
  QUICK_ACTIONS: {
    TOOLTIP: 'Quick actions',
    COMMAND_SENT: 'Command sent',
    COMMAND_FAILED: 'Command failed'
  },
  EDIT_SESSION: 'Edit Session',
  DELETE_SESSION: 'Delete Session',
  SET_CURRENT_END_TIMESTAMP: 'Set end timestamp to now',
  AUTOMATIC_PAY_AFTER_SAVE: 'Calculate cost automatically',
  MAKE_PAYMENT_AFTER_SAVE: 'Initiate payment after saving',
  SESSION_WITH_BOOKING: 'Session with booking',
  SEARCH_BY_NAME_OR_EMAIL: 'Search by name or email',
  VEHICLE_GROUPS: {
    TITLE: 'Vehicle groups',
    GROUP_NAME: 'Group name',
    ADD_NEW: 'Add new',
    EDIT: 'Edit',
    PUT_SUCCESSFUL: 'Successfully changed',
    POST_SUCCESSFUL: 'Successfully added',
    LICENSE_PLATES: 'License plates',
    LICENSE_PLATE: 'License plate',
    LICENSE_PLATES_POST_SUCCESSFUL: 'List updated successfully',
    LICENSE_PLATE_IMPORT_WARNING_MESSAGE:
      'You are about to import these license places:',
    DELETE_SUCCESSFUL: 'Delete successful',
    LICENSE_PLATE_DELETE_WARNING_MESSAGE:
      'You are about to delete license plate:',
    ENTER_NEW_LICENSE_PLATE: 'Enter new car license plate in format 123ABC',
    REMOVE_EXISTING_VEHICLES: 'Remove existing vehicles'
  },
  ADD_NEW: 'Add new',
  CAR_WASH_DISPUTES: {
    TITLE: 'Disputes',
    CREATED_AT: 'Created at',
    LICENSE_PLATE: 'License plate',
    STATUS: 'Status',
    EDIT_DISPUTE: 'Edit',
    SERVICE_TIME: 'Service time',
    EDIT: 'Edit dispute',
    AMOUNT: 'Amount',
    MESSAGE: 'Message',
    REJECT: 'Reject',
    APPROVE: 'Approve',
    ALL_DISPUTES: 'All disputes',
    PLACE_NAME: 'Place name',
    SERVICE_NAME: 'Service name'
  },
  SEARCH_BY_PLACE_FLEET_OR_WHITELIST_NAME: 'Place, fleet or whitelist name',
  PRICE: 'Price',
  FROM_PREVIOUS_MONTH_START: 'From previous month start',
  PREVIOUS_MONTH: 'Previous month',
  CURRENT_MONTH: 'Current month',
  PREVIOUS_WEEK: 'Previous week',
  CURRENT_WEEK: 'Current week',
  YESTERDAY: 'Yesterday',
  TODAY: 'Today',
  LAST_7_DAYS: 'Last 7 days',
  PARKED_MINUTES: 'Parked minutes',
  OVERTIME_MINUTES: 'Overtime in minutes',
  GATE_CONTROLLERS: {
    ADD_NEW: 'Add new',
    ACTIONS: 'Actions',
    RESTART: 'Restart',
    PIN_STATES: 'Pin states',
    OUTPUT_PIN_STATES: 'Output pin states',
    LAST_HEARTBEAT: 'Last heartbeat',
    SIGNAL_STRENGTH: 'Signal strength',
    OPEN: 'Open'
  }
}
